/**
 *
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 *
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";
import ServiceConstant from "@/app/core/ServiceConstant";

export default class PatientRequest extends MainRequest {
  static addPatient(data) {
    return this.postFILESEC(ServicePath.PATIENT_ADD, data);
  }

  static listAllPatients() {
    return this.getSEC(ServicePath.PATIENT_LIST_ALL);
  }

  static updatePatient(data) {
    return this.postSEC(ServicePath.PATIENT_UPDATE, data);
  }

  static deletePatient(data) {
    return this.postSEC(ServicePath.PATIENT_DELETE, data);
  }

  static listPatientById(data) {
    return this.postSEC(ServicePath.PATIENT_LIST_BY_ID, data);
  }

  static listPatientClinicHistory() {
    return this.getSEC(ServicePath.PATIENT_FIND_HISTORICAL_CLINIC);
  }

  static getPatientInfoClinicHistory(data) {
    return this.postSEC(ServicePath.PATIENT_PERSONAL_INFO, data);
  }

  static listAllPatientsPending() {
    return this.getSEC(ServicePath.PATIENT_LIST_ALL_PENDING);
  }

  static validCurpPatient(data) {
    return this.postSEC(ServicePath.PATIENT_VALID_CURP, data);
  }

  static listAllPatientsByBranchOffice(data) {
    return this.postSEC(ServicePath.PATIENT_LIST_ALL_BY_BRANCH_OFFICE, data);
  }

  static listPatientsByDate(data) {
    return this.postSEC(ServicePath.PATIENT_LIST_ALL_BY_DATE, data);
  }

  static findAllPatientsReceptionPaged(params) {
    return this.postSEC(ServicePath.PATIENT_LIST_RECEPTION_PAGINATION, params);
  }
  static getConfigReception(data) {
    return this.postSEC(ServicePath.CONFIGURATION_GET_CONFIG_RECEPTION, data);
  }
  static listJobs(data){
    return this.getSEC(ServiceConstant.LIST_JOBS, data);
  }
  /**Paginado */
  static listPatientsPagination(params) {
    return this.postSEC(ServiceConstant.PATIENT_MNGT_LIST_PAGED_RECEPTION, params);
  }
}
